"use strict";

import {isParsleyForm, isValid} from "./parsley";

export function initInScope ($scope) {

    $scope.find('.js-disable-after-submit').on('submit', function (evt) {
        let $form = $(this);

        if (isParsleyForm($form) && isValid($form)) {
            $form.find('.btn').attr('disabled','disabled');
        }
    });

    $scope.find('.js-disable-after-click').on('click', function (evt) {
        if ($(this).hasClass("link-is-disabled")) {
            evt.preventDefault();
        }
        $(this).addClass("link-is-disabled");
    });
}